<template>
  <div class="jps-card-view" :class="{ 'jps-editable': editable }">
    <UiCarouselWithButton tag="ul" :item-width="256" :item-gap="16">
      <li
        v-for="item in items"
        :key="item.key"
        :id="item.key"
      >
        <div
          class="ui-carousel-item jps-card"
        >
          <div class="list-card-edit-button">
            <UiButtonIcon
              v-if="editable"
              tag="button"
              class="jps-icon-button jps-sub-orange list-delete"
              @click.stop="emits('delete-item', item)"
              icon="mdi/close-circle"
            />
          </div>
          <template v-if="!item.readNext">
            <div class="jps-card-img" aria-hidden="true">
              <BaseLink
                v-bind="baseLinkProps(item)"
                class="card-image"
                @click="emits('show-modal', item)"
                :show-icon="false"
              >
                <UiImageSelection
                  :image="item.image"
                  :type="noImgType(item)"
                  :appearance="{
                    borderRadius: 'small',
                    hoverScale: true,
                  }"
                  image-usage="thumbnail"
                />
                <div class="list-card-edit-button">
                  <ListEditIcon :item="item" field="image" :editstate="editstate" />
                </div>
              </BaseLink>
            </div>
            <div class="jps-card-body" :class="`height-${height}`">
              <h3 class="jps-card-title">
                <BaseLink
                  v-bind="baseLinkProps(item)"
                  @click="emits('show-modal', item)"
                  class="text"
                >
                  {{ ls(item.title) }}
                  <ListEditIcon :item="item" field="title" :editstate="editstate" />
                  <ListEditIcon :item="item" field="url" :editstate="editstate" />
                  <ListEditIcon :item="item" field="linkUrl" :editstate="editstate" />
                </BaseLink>
              </h3>
              <div class="scroll-content">
                <p class="jps-card-meta" v-if="!isEmpty(item.contributor)">
                  {{ ljoin(item.contributor) }}
                </p>
                <p class="jps-card-meta" v-if="isJps && item.type === 'item' && item.data">
                  <UiOrgProviderSpan :id="item.data.common.provider" />
                </p>
                <p class="jps-card-content is-size-7">
                  <ListEditIcon
                    :item="item"
                    field="description"
                    :editstate="editstate"
                  />
                  {{ ls(item.description) }}
                </p>
              </div>
            </div>
          </template>
          <SearchResultDiv v-else :item="item" :editstate="editstate" />
          <div class="jps-card-icon">
            <UiInteractPanel
              v-if="item.data && !editable"
              :type="item.type"
              :data="item.data"
              :image="item.image"
            />
            <div v-else /><!-- liner-gradient を定義する空要素 -->
          </div>
        </div>
      </li>
    </UiCarouselWithButton>
    <div v-if="editable && !isNote">
      <button
        class="jps-icon-button list-add-button jps-sub-orange"
        @click="emits('add')"
      >
        <BaseIcon name="mdi/plus-circle" :alt="ls(addPartMsg)" size="size-4" />
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { ls, ljoin } = useI18n()
const { isJps } = useServiceType()

interface Props {
  editstate?: CurationEditState
  def : PartList
  items: ListElement[]
  height?: 'auto' | 'middle'
}
const props = withDefaults(defineProps<Props>(), {
  height: 'auto',
})

const emits = defineEmits(['delete-item', 'show-modal', 'add'])

const {
  isNote,
  hasExternalLink,
  baseLinkProps,
  editable,
  addPartMsg,
  noImgType,
} = useCurationListView(props.editstate, props.def)
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-card-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* @apply mx-0 md:mx-[-3rem]; */

  .jps-card {
    .jps-card-body {
      cursor: auto !important;
    }
    .jps-card-icon {
      pointer-events: none;
      .jps-interact-panel {
        pointer-events: initial;
      }
    }

    .scroll-content {
      overflow-y: scroll;
      height: calc(100% - 2rem);
      @include no-scrollbar();

      .jps-card-content {
        &, :deep(p) {
          line-height: 1.3125rem;
        }
      }
    }
  }
  &.jps-editable {
    margin-left: 0rem;
    margin-right: 0rem;
  }

  .list-card-edit-button {
    :deep(.jps-icon-button) {
      margin-right: 6px;
    }
  }

  .list-delete {
    position: absolute;
    top: 8px;
    right: 2px;
    background-color: $jps-gray-50;
  }
  .jps-show-more {
    min-height: 290px;
  }
}
.curation-parts-editor .jps-card {
  border-width: 1px;
  border-color: $jps-gray-300;
  border-style: solid;
  /* @include panel-shadow; */
}

.jps-card-img {
    overflow: hidden;
    border-radius: 0.25rem;
}

.height-middle {
  height: 8rem;
}

.height-auto {
  min-height: 8rem;
}
</style>
